import dayjs from 'dayjs';
import { Resolver } from 'react-hook-form';

import { t } from '@gem/modules/i18n';

import { STEP } from 'APP/constants/calendar';

import { IFormData } from '../Form.types';

export const customResolver: Resolver<IFormData> = (values) => {
  const { title, startTime, endTime, start, end, allDay } = values;
  const errors: Record<
    string,
    {
      type: string;
      message?: string;
      types?: { [key: string]: string };
    }
  > = {};

  if (!title.trim()) {
    errors.title = {
      type: 'required',
      message: t('common_required_field_error', { '0': t('calendar_event_title') }),
    };
  }

  const [HH, mmStart] = startTime.split(':');
  const [HHEnd, mmEnd] = endTime.split(':');
  const formattedStart = dayjs(start).hour(+HH).minute(+mmStart);
  const formattedEnd = dayjs(end).hour(+HHEnd).minute(+mmEnd);
  const mmEndRemainder = +mmEnd % STEP;
  const mmStartRemainder = +mmStart % STEP;
  const endTimeTypes: {
    mustBeAfterStart?: string;
    timeAllowedValues?: string;
  } = {};

  if (mmStartRemainder && !allDay) {
    errors.startTime = {
      type: 'timeAllowedValues',
      message: t('calendar_time_allowed_values'),
    };
  }

  if (formattedStart.isAfter(formattedEnd) || formattedStart.isSame(formattedEnd)) {
    endTimeTypes.mustBeAfterStart = t('calendar_endtime_mustbeafterstart');
  }

  if (mmEndRemainder && !allDay) {
    endTimeTypes.timeAllowedValues = t('calendar_time_allowed_values');
  }

  if (Object.keys(endTimeTypes).length > 0) {
    errors.endTime = {
      type: 'multiple',
      types: endTimeTypes,
    };
  }

  return {
    values: Object.keys(errors).length > 0 ? {} : values,
    errors,
  };
};
